module.exports = __webpack_public_path__ + "static/img/case_logo_01.c3d3e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_logo_01.png
// module id = kFAk
// module chunks = 34